import L from 'leaflet';

export const pointStyles = {
  default: {
    radius: 5,
    fillColor: '#3388ff',
    color: '#fff',
    weight: 1,
    opacity: 1,
    fillOpacity: 0.8,
  },
  Destinations_Muster_Stations: {
    radius: 8,
    fillColor: '#ff7800',
    color: '#fff',
    weight: 2,
    opacity: 1,
    fillOpacity: 0.9,
  },
  RDCO_Evac_Zone_Centroids_v1_358: {
    radius: 6,
    fillColor: '#00ff00',
    color: '#000',
    weight: 1,
    opacity: 1,
    fillOpacity: 0.7,
  },
  addresses: {
    radius: 4,
    fillColor: '#ff0000',
    color: '#fff',
    weight: 1,
    opacity: 1,
    fillOpacity: 0.6,
  },
  CRD_PostSecondary_Schools_v1: {
    radius: 7,
    fillColor: '#8000ff',
    color: '#fff',
    weight: 2,
    opacity: 1,
    fillOpacity: 0.8,
  },
  CRD_Grade_Schools_v1: {
    radius: 6,
    fillColor: '#00ffff',
    color: '#000',
    weight: 2,
    opacity: 1,
    fillOpacity: 0.8,
  },
  CRD_Transit_Stops_v1: {
    radius: 5,
    fillColor: '#ffaa00',
    color: '#000',
    weight: 1,
    opacity: 1,
    fillOpacity: 0.7,
  },
};

export const lineStyles = {
  default: {
    color: '#000000ff',
    weight: 5,
    opacity: 0.8,
    dashArray: '10, 10',
  },
  gmap_route: {
    color: '#000000ff',
    weight: 5,
    opacity: 0.8,
    dashArray: '10, 10',
  },
  CRD_Transit_Routes_v1: {
    color: '#33aaffff',
    weight: 3,
    opacity: 0.6,
  },
  CRD_Model_Road_Network_v1: {
    color: '#d400ffff',
    weight: 3,
    opacity: 0.6,
  }
};

export const areaStyles = {
  default: {
    fillColor: '#3388ff',
    weight: 2,
    opacity: 1,
    color: '#3388ff',
    fillOpacity: 0.3,
  },
  RDCO_Evac_Zones_v1_358: {
    fillColor: '#ffff00',
    weight: 2,
    opacity: 1,
    color: '#ffff00',
    fillOpacity: 0.2,
  },
  CRD_TAZ_2025_v2: {
    fillColor: '#00ff00',
    weight: 1,
    opacity: 0.5,
    color: '#000',
    fillOpacity: 0.15,
  },
  CRD_Municipal_Boundaries_v1: {
    fillColor: '#888888',
    weight: 3,
    opacity: 1,
    color: '#ff0000ff',
    fillOpacity: 0.1,
  },
};

export const customIcons = {
  musterStation: L.icon({
    iconUrl: '/assets/img/leaflet/muster_icon_50.png',
    iconSize: [25, 25],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12],
  }),
  musterStationSelected: L.icon({
    iconUrl: '/assets/img/leaflet/muster_icon_50.png',
    iconSize: [50, 50],
    iconAnchor: [25, 25],
    popupAnchor: [0, -25],
  }),
};

export const getStyle = (layerType, layerName) => {
  if (layerType === 'point') {
    return pointStyles[layerName] || pointStyles.default;
  } else if (layerType === 'line') {
    return lineStyles[layerName] || lineStyles.default;
  } else {
    return areaStyles[layerName] || areaStyles.default;
  }
};

export const getSelectionStyle = (layerType, originalStyle) => {
  if (layerType === 'point') {
    return {
      fillColor: '#ff0000',
      color: '#ff0000',
      weight: originalStyle.weight + 1,
      fillOpacity: 0.9,
      opacity: 1,
      radius: originalStyle.radius + 2,
    };
  } else if (layerType === 'line') {
    return {
      color: '#ff0000',
      weight: originalStyle.weight + 2,
      opacity: 1,
    };
  } else {
    return {
      color: '#ff0000ff',
      fillColor: '#0dff00ff',
      weight: originalStyle.weight + 6,
      fillOpacity: originalStyle.fillOpacity,
      opacity: 1,
    };
  }
};

export const getHoverStyle = (layerType, originalStyle) => {
  if (layerType === 'point') {
    return {
      fillColor: '#ff0000',
      color: '#ff0000',
      weight: originalStyle.weight + 1,
      fillOpacity: 0.9,
      opacity: 1,
      radius: originalStyle.radius + 2,
    };
  } else if (layerType === 'line') {
    return {
      color: '#ff0000',
      weight: originalStyle.weight + 2,
      opacity: 1,
    };
  } else {
    return {
      color: '#ff0000',
      fillColor: '#ff0000',
      weight: originalStyle.weight + 2,
      fillOpacity: Math.min((originalStyle.fillOpacity || 0.3) + 0.2, 1),
      opacity: 1,
    };
  }
};